import {Injectable} from '@angular/core'
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router'
import {TopicOverviewPage} from '../../../../core/content/types/article.types'
import {Observable} from 'rxjs'
import {ResolverUtilService} from '../../../../core/resolver/resolver-util.service'
import {catchError} from 'rxjs/operators'
import {ArticleContentService} from '../../../../core/content/services/article-content.service'

export type TopicOverviewPageResolved = TopicOverviewPage

@Injectable()
export class TopicOverviewResolver {
  constructor(
    private readonly contentService: ArticleContentService,
    private readonly util: ResolverUtilService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TopicOverviewPageResolved> {
    const slug = route.paramMap.get('pageSlug')
    if (!slug) {
      return this.util.redirectToNotFound(state.url)
    }

    return this.contentService.getTopicOverviewPage(slug).pipe(catchError(e => this.util.handleError(e, state.url)))
  }
}
